import { User, UserTenant, UserTenants } from "../types/User";

export function getCurrentTenant(user: User) {
  if (user !== undefined && user.tenants !== undefined) {
    const tenant: UserTenants = user.tenants.find(
      (e: UserTenants) => e.tenantId === user.activeTenantId,
    )!;
    if (tenant !== undefined && tenant.tenant !== undefined) {
      return tenant?.tenant;
    }
  }
  return undefined;
}

export function getExternalTenantId(user: User): string {
  const tenant: UserTenant | undefined = getCurrentTenant(user);
  if (tenant !== undefined && tenant.externalId !== undefined) {
    return tenant.externalId;
  }
  return "";
}

export function getCurrentTenantName(user: User): string {
  const tenant = getCurrentTenant(user);
  if (tenant !== undefined && tenant.name !== undefined) {
    return tenant.name;
  }
  return "";
}
